var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 40.59c11.046 0 20-8.955 20-20 0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20z",
    fill: "#CBF3EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.89 16.536c1.75.596 4.068.925 6.528.925 2.461 0 4.78-.329 6.528-.925 1.864-.636 2.89-1.527 2.89-2.51 0-.984-1.026-1.876-2.89-2.512-1.749-.596-4.067-.924-6.528-.924-2.46 0-4.779.328-6.527.925-1.864.635-2.891 1.527-2.891 2.51 0 .984 1.027 1.875 2.89 2.51z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.194 17.846c-.148 0-.308.05-.49.152-.267.152-.606.269-.964.392l-.104.036c-1.957.677-4.52 1.05-7.218 1.05-2.697 0-5.26-.373-7.217-1.05-.553-.191-.707-.252-.912-.357a1.261 1.261 0 0 0-.575-.164.67.67 0 0 0-.67.503 1.47 1.47 0 0 0-.044.354c0 .998 1.027 1.902 2.89 2.546 1.75.605 4.068.938 6.528.938 2.461 0 4.78-.333 6.528-.938 1.864-.644 2.89-1.548 2.89-2.546a1.49 1.49 0 0 0-.075-.465c-.129-.393-.41-.451-.567-.451z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.194 22.481c-.147 0-.307.05-.489.153-.268.151-.606.268-.964.391l-.105.036c-1.957.677-4.52 1.05-7.218 1.05-2.697 0-5.26-.373-7.217-1.05-.553-.191-.707-.251-.912-.356a1.26 1.26 0 0 0-.575-.165.67.67 0 0 0-.67.504 1.47 1.47 0 0 0-.044.354c0 .997 1.027 1.901 2.89 2.546 1.75.605 4.068.938 6.528.938 2.461 0 4.78-.334 6.528-.938 1.864-.645 2.89-1.549 2.89-2.546a1.49 1.49 0 0 0-.075-.466c-.129-.392-.41-.45-.567-.45z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.194 27.113c-.148 0-.308.05-.49.153-.268.152-.606.268-.965.392l-.103.035c-1.957.677-4.52 1.05-7.218 1.05-2.697 0-5.26-.373-7.217-1.05-.553-.19-.707-.251-.912-.356a1.26 1.26 0 0 0-.575-.164.67.67 0 0 0-.67.503 1.47 1.47 0 0 0-.044.354c0 .997 1.027 1.901 2.89 2.546 1.75.605 4.068.938 6.528.938 2.461 0 4.78-.333 6.528-.938 1.864-.645 2.89-1.549 2.89-2.546 0-.155-.025-.311-.075-.466-.129-.392-.41-.45-.567-.45z",
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 29.837,
    y1: 10.59,
    x2: 10.613,
    y2: 11.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 50.001,
    y1: 16.5,
    x2: 43.55,
    y2: 31.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBF3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 21.43,
    y1: 14.873,
    x2: 20.16,
    y2: 26.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 21.43,
    y1: 19.505,
    x2: 20.16,
    y2: 31.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0ECE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFees);
export default __webpack_public_path__ + "static/media/iconFees.b97a2f7488e60de4503541e17a4531f3.svg";
export { ForwardRef as ReactComponent };